import {
  BlockModel,
  BlockSchemaExtension,
  defineBlockSchema,
} from '@blocksuite/affine/store';

/**
 * Deep-research-result block — Phase C custom BlockSuite block.
 *
 * Twin of `affine:analyze-result` but for the multi-document
 * synthesis flow. Stores the full result + bundle summary as JSON
 * strings (BlockSuite's Y.Doc CRDT diffs them as atomic units).
 */
type DeepResearchResultProps = {
  /**
   * Serialised result payload — every Phase B field on the
   * DeepResearchModeResult (extractionRows, conflicts, gaps,
   * methodsParagraph, capsule, synthesisStructure, …).
   * JSON string. Always non-empty when the block is created.
   */
  deepResearchResultJson: string;
  /**
   * Serialised bundle summary (themes, scope, doc count, dataTypes).
   * JSON string. May be empty for cached follow-up turns where the
   * profile is no longer in scope.
   */
  bundleSummaryJson: string;
};

export const DeepResearchResultBlockSchema = defineBlockSchema({
  flavour: 'affine:deep-research-result',
  props: (): DeepResearchResultProps => ({
    deepResearchResultJson: '',
    bundleSummaryJson: '',
  }),
  metadata: {
    version: 1,
    role: 'content',
    children: [],
  },
  toModel: () => new DeepResearchResultBlockModel(),
});

export const DeepResearchResultBlockSchemaExtension = BlockSchemaExtension(
  DeepResearchResultBlockSchema
);

export class DeepResearchResultBlockModel extends BlockModel<DeepResearchResultProps> {}
